import { ref } from 'vue';

import { defineStore } from 'pinia';

import { fetchCountry } from '@/api/internal';
import { Country } from '@/types/components';

export const useCountryStore = defineStore('country', () => {
  /* states */
  const countries = ref<Country[]>([]);
  const isLoading = ref<boolean>(false);

  /* actions */
  const requestCountries = async () => {
    if (countries.value.length > 0) {
      return;
    }
    isLoading.value = true;

    try {
      const res = await fetchCountry();

      if (!res.ok) {
        throw new Error();
      }

      const { data = {} } = await res.json();
      countries.value = data;
    } catch {
      countries.value = [];
    } finally {
      isLoading.value = false;
    }
  };

  const getCountryByCode = (countryCode: string): Country => {
    return countries.value.find((country) => country.code === countryCode) as Country;
  };

  return {
    countries,
    requestCountries,
    getCountryByCode,
  };
});
